<template>
  <ScrollableList>
    <template #items>
      <Item
        v-if="showSiteItem"
        :isChecked="isSiteChecked"
        :showCheckbox="showCheckbox"
        class="text-tertiary"
        @check="
          (checked) => $emit('check', { type: LinkedToType.SITE, checked })
        "
      >
        <template #content>
          <div class="flex flex-col overflow-hidden">
            <span class="font-medium text-base truncate">
              {{ t("components.filters.site.label") }}
            </span>
          </div>
        </template>
      </Item>
      <Item
        :isIndeterminate="isSpacesIndeterminate"
        :isChecked="isSpacesChecked"
        :showCheckbox="showCheckbox"
        showChevron
        class="text-tertiary"
        @click="$emit('click', LinkedToType.SPACES)"
        @check="
          (checked) => $emit('check', { type: LinkedToType.SPACES, checked })
        "
      >
        <template #content>
          <div class="flex flex-col overflow-hidden">
            <span class="font-medium text-base truncate">
              {{ t("components.filters.spaces_or_assets.spaces") }}
            </span>
          </div>
        </template>
      </Item>
      <Item
        :isIndeterminate="isAssetsIndeterminate"
        :isChecked="isAssetsChecked"
        :showCheckbox="showCheckbox"
        showChevron
        class="text-tertiary"
        @click="$emit('click', LinkedToType.ASSETS)"
        @check="
          (checked) => $emit('check', { type: LinkedToType.ASSETS, checked })
        "
      >
        <template #content>
          <div class="flex flex-col overflow-hidden">
            <span class="font-medium text-base truncate">
              {{ t("components.filters.spaces_or_assets.assets") }}
            </span>
          </div>
        </template>
      </Item>
    </template>
  </ScrollableList>
</template>

<script setup>
import { ScrollableList, Item } from "@/Components/List";
import { LinkedToType } from "@/Components/LinkedTo";
import { useI18n } from "vue-i18n";
import { computed } from "vue";

defineEmits(["check", "click"]);

const props = defineProps({
  checkedTypes: {
    type: Array,
    default: () => [],
  },
  indeterminateTypes: {
    type: Array,
    default: () => [],
  },
  showCheckbox: {
    type: Boolean,
    default: true,
  },
  showSiteItem: {
    type: Boolean,
    required: false,
  },
});

const { t } = useI18n();

const isSiteChecked = computed(() => {
  return props.checkedTypes.includes(LinkedToType.SITE);
});

const isSpacesChecked = computed(() => {
  return props.checkedTypes.includes(LinkedToType.SPACES);
});

const isAssetsChecked = computed(() => {
  return props.checkedTypes.includes(LinkedToType.ASSETS);
});

const isSpacesIndeterminate = computed(() => {
  return props.indeterminateTypes.includes(LinkedToType.SPACES);
});

const isAssetsIndeterminate = computed(() => {
  return props.indeterminateTypes.includes(LinkedToType.ASSETS);
});
</script>
